import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { EntityStatus } from './entity-status.type';
import { GuidName } from './guid-name.type';

const Entity = t.intersection(
  [
    GuidName,
    t.type({
      entityType: t.string,
      entityNumber: t.string,
      status: nullable(EntityStatus),
    }),
  ],
  'Entity',
);

type Entity = t.TypeOf<typeof Entity>;
export { Entity };
